import { Button } from "antd";
import title from "../../conf/title"
import { Link } from "react-router-dom";
import { DownloadKind, downloadStaticFile } from "../../unit/download";

const Home = () => {
    return (
        <div>
            <div className="banner">
                <img src="/images/banner.jpg" alt="" />
            </div>
            <div className="items">
                <div className="item">
                    <div className="block">
                        <div className="icon_pan">
                            <Link to="/creditApply/post"><img src="images/form.png" width="50" alt="" /></Link>
                        </div>
                        <Link to="/creditApply/post">信用申请</Link>
                        <p className="info">支持合作伙伴在下单前提交信审</p>
                    </div>
                </div>
                <div className="item">
                    <div className="block">
                        <div className="icon_pan">
                            <Link to="/guaranteeAdd/post"><img src="images/wan_money.png" width="50" alt="" /></Link>

                        </div>
                        <Link to="/guaranteeAdd/post">担保申请</Link>
                        <p className="info">支持合作伙伴向21V提供保函或保证金作为担保</p>
                    </div>
                </div>
                <div className="item">
                    <div className="block">
                        <div className="icon_pan">
                            <Link to="/guaranteeWithdraw/post"><img src="images/Mail.png" width="50" alt="" /></Link>
                        </div>
                        <Link to="/guaranteeWithdraw/post">担保提取</Link>
                        <p className="info">
                            支持合作伙伴在每个季度的第二个月调整保函或保证金
              </p>
                    </div>
                </div>
                <div className="item">
                    <div className="block">
                        {/* <h2 className="blue">文件下载</h2>
                        <p></p> */}
                        <div className="icon_pan">
                            <Link to="/download"><img src="images/file.jpg" width="50" alt="" /></Link>
                        </div>
                        <Link to="/download">{title.download}</Link>
                        <p className="info">支持合作伙伴下载相关文件</p>
                        {/* <><Button className="download_text" type="link" onClick={() => {
                            downloadStaticFile(DownloadKind.CorpGuaranteeApply)
                        }}>《保证金协议》下载</Button>
                            <Button className="download_text" type="link" onClick={() => {
                                downloadStaticFile(DownloadKind.GuaranteeImplement)
                            }}>《履约保函》下载</Button>
                            <Button className="download_text" type="link" onClick={() => {
                                downloadStaticFile(DownloadKind.DepositAgreement)
                            }}>《申请银行保函说明》下载</Button></> */}
                    </div>
                </div>
            </div>
            <div style={{paddingBottom:'10px'}}><p style={{textAlign: 'center',margin:'20px'}}><a href="https://www.21vbluecloud.com/privacy-policy/" target="_blank">隐私声明</a></p></div>
        </div>
    );
};

export default Home